export enum CommandName {
  Clear = 'clear',
  Load = 'load',
  Undo = 'undo',
  Redo = 'redo',
}

export interface Command {
  name: CommandName;
}

/**
 * Command clears entire main canvas content.
 */
export class ClearCommand implements Command {
  name = CommandName.Clear;
}

/**
 * Command allows to load new state of main canvas from dataUrl.
 */
export class LoadCommand implements Command {
  name = CommandName.Load;

  /**
   * Command allows to load new state of main canvas from dataUrl.
   * @param state DataUrl of image. Example: `data:image/png;base64,iVBORw0KGgoAA...`
   */
  constructor(public state: string) {}
}

export const CANVAS_DEFAULT_WIDTH_PX = 1800;
export const CANVAS_DEFAULT_HEIGHT_PX = 900;

/**
 * Command moves main canvas in time one step backward.
 */
export class UndoCommand implements Command {
  name = CommandName.Undo;
}

/**
 * Command moves main canvas in time one step forward. Works only if canvas has been undone before.
 */
export class RedoCommand implements Command {
  name = CommandName.Redo;
}

export type TextbookDrawerCommand = ClearCommand | LoadCommand | UndoCommand | RedoCommand;
